module.exports = __webpack_public_path__ + "img/4.f46fc7f0.svg";